import { type AccountData, HOUR, type AccountId, type AccountGetInput, type AccountGetSuccess } from '@terros/common'
import { useTantalimQuery } from '../query'
import { accountKey } from '../keys'
import { type GetHookResponse } from '../hooks'
import { useAccountCache } from './cache'

const EMPTY_ACCOUNT_ID: AccountId = 'Account.EMPTY_ACCOUNT'
export function useAccount(accountId: AccountId | undefined = EMPTY_ACCOUNT_ID): GetHookResponse<AccountData> {
  const { getItem } = useAccountCache()
  const enabled = accountId !== EMPTY_ACCOUNT_ID
  return useTantalimQuery<AccountGetInput, AccountGetSuccess, AccountData>({
    url: '/account/get',
    queryKey: accountKey(accountId),
    input: { accountId },
    convertResponse: (data) => data.account,
    options: {
      gcTime: HOUR,
      staleTime: HOUR,
      placeholderData: getItem(accountId),
      enabled,
    },
  })
}
